(function(angular) {
    angular.module('wtUi')

        /**
         * @ngdoc directive
         * @name onNgRepeatDone
         * @description Directive for triggering custom logic when ng-repeat has finished.
         * Add the directive to the element containing ng-repeat and pass the expression to be evaluated as attribute value
         */
        .directive('onNgRepeatDone', ['$timeout', function($timeout) {
            return {
                link: function($scope, $element, $attrs) {
                    // Triggered on last element of the ng-repeat
                    if ($scope.$last) {
                        $timeout(() => ($scope.$eval($attrs.onNgRepeatDone)));
                    }
                }
            };
        }]);
})(window.angular);
